<div class="tuonnit-container">
  <h2 style="margin-top: 0">Tuonnit</h2>

  <mat-tab-group [(selectedIndex)]="aktiivinenTabiIndex" dynamicHeight>
    <mat-tab label="Asiakkaat">
      <app-asiakas-import></app-asiakas-import>
    </mat-tab>
    <mat-tab label="Tuotteet">
      <app-tuote-import></app-tuote-import>
    </mat-tab>
    <mat-tab label="Toimittajat">
      <app-toimittaja-import></app-toimittaja-import>
    </mat-tab>
    <mat-tab label="Alkusaldot">
      <app-alkusaldo-import></app-alkusaldo-import>
    </mat-tab>
  </mat-tab-group>
</div>
